export default __webpack_public_path__ + "static/media/rocket.85db6492.png";